<template>
  <div
    class="modal fade"
    role="dialog"
    id="repricing-edit-modal"
    ref="repricingEditModal"
  >
    <div class="modal-dialog modal-xs">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body modal-confirmation">
          <div class="row text-center">
            <div class="col-sm-12">
              <div class="modal-wrapper">
                <div class="warn__icon">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        fill="currentColor"
                        d="M228.9,79.9L51.8,403.1C40.6,423.3,55.5,448,78.9,448h354.3c23.3,0,38.2-24.7,27.1-44.9L283.1,79.9
		C271.4,58.7,240.6,58.7,228.9,79.9z M273.6,214L270,336h-28l-3.6-122H273.6z M256,402.4c-10.7,0-19.1-8.1-19.1-18.4
		s8.4-18.4,19.1-18.4s19.1,8.1,19.1,18.4S266.7,402.4,256,402.4z"
                      ></path>
                    </g>
                  </svg>
                </div>
                <p>
                  {{ message }}
                </p>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="cancel">
                    Cancel
                  </button>
                  <template v-if="buttonProcess">
                    <button
                      type="submit"
                      class="btn btn-submit"
                      @click="submit"
                    >
                      Proceed
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.modal-body -->
      </div>
      <!-- /.modal-content -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "",
      index: "",
      label: "",
      buttonProcess: true,
    };
  },
  created() {
    this.$eventBus.$on("ConfirmEdit", this.initialize);
  },
  methods: {
    initialize(index, message, label, buttonProcess) {
      this.index = index;
      this.message = message;
      this.label = label;
      this.buttonProcess = buttonProcess;
      setTimeout(() => {
        $(this.$refs.repricingEditModal).modal({
          backdrop: "static",
          keyboard: false,
        });
      }, 200);
    },
    cancel() {
      this.index = null;
      this.message = "";
      $(this.$refs.repricingEditModal).modal("hide");
    },
    submit() {
      this.$emit("submit", this.index, this.label);
      this.cancel();
    },
  },
};
</script>
<style scoped>
.warn__icon {
  color: #eb0011;
}
.warn__icon svg {
  width: 100px;
  height: 100px;
}
.btn.btn-submit {
  background: #4fb848;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-submit:hover {
  background: #339c2b;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalConfirmUpdate.vue